import React from 'react';

type Props = {
    children?: React.ReactNode;
};

export default function GameWrapper({ children }: Props) {
    return <div className="game-wrapper">{children}</div>;
}
